module.exports = __webpack_public_path__ + "static/media/Component 331.f7d429bc.svg";